module.exports = __webpack_public_path__ + "static/media/flasche.6772179a.jpg";